import {Col, Form, Row, Tab, Tabs} from "react-bootstrap";
import {ModalDialog} from "../modal/ModalDialog.js";
import React from "react";
import {APIClient} from "../../core/utils/APIClient.js";
import useForm from "../../core/hooks/useForm.js";
import {fetchPromises} from "../../core/utils/fetchPromises.js";

function ArticleModal({setModal, article, retailers, scanners, brands, categories}) {
    const {form, onInputChange, onNumberChange} = useForm({
        brandId: brands && brands[0].id,
        categoryId: categories && categories[0].id,
        ...article,
        scanners: transformScannersToObject(scanners),
    });

    const onModalSaveClick = async () => {
        try {
            await APIClient().saveArticle(form);

            setModal({
                show: false
            });
        } catch (e) {
            console.error(e);
        }
    }

    const onModalClose = () => {
        setModal({
            show: false
        });
    }

    return (
        <ModalDialog show onClose={onModalClose} onCallback={onModalSaveClick} title="Article">
            <Tabs
                defaultActiveKey="details"
                id="uncontrolled-tab-example"
                className="mb-3"
            >
                <Tab eventKey="details" title="Details">
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="3">
                            Name
                        </Form.Label>
                        <Col sm="9">
                            <Form.Control type="text" name="name" value={form.name || ''} onChange={onInputChange} required />
                            <Form.Control.Feedback type="invalid">
                                Field is required.
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="3">
                            Description
                        </Form.Label>
                        <Col sm="9">
                            <Form.Control as="textarea" rows={3} name="description" value={form.description || ''} onChange={onInputChange} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 align-items-center">
                        <Form.Label column sm="3">
                            Piece Volume (ml)
                        </Form.Label>
                        <Col>
                            <Form.Control type="text" name="pieceVolumeMl" onChange={onNumberChange} value={form.pieceVolumeMl || ''} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="3">
                            Brand
                        </Form.Label>
                        <Col sm="9">
                            <Form.Select name="brandId" onChange={onInputChange} value={form.brandId}>
                                {brands && brands.map((c, index) =>
                                    <option key={index} value={c.id} defaultValue={c.id === form.brandId}>{c.name}</option>
                                )}
                            </Form.Select>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="3">
                            Category
                        </Form.Label>
                        <Col sm="9">
                            <Form.Select name="categoryId" onChange={onInputChange} value={form.categoryId}>
                                {categories && categories.map((c, index) =>
                                    <option key={index} value={c.id} defaultValue={c.id === form.categoryId}>{c.name}</option>
                                )}
                            </Form.Select>
                        </Col>
                    </Form.Group>
                </Tab>
                <Tab eventKey="scanners" title="Scanners">
                    {retailers && retailers.map((r, index) =>
                        <Form.Group key={index} as={Row} className="mb-3">
                            <Form.Label column sm="3">
                                {r.name}
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    name={`[scanners][${r.id}]`}
                                    value={(form.scanners && form.scanners[r.id]) || ''}
                                    onChange={onInputChange}
                                />
                            </Col>
                        </Form.Group>
                    )}
                </Tab>
            </Tabs>
        </ModalDialog>
    );
}

export default fetchPromises({
    article: (props) => props.articleId && ({ name: 'getArticle', props: ['articleId'] }),
    retailers: () => ({ name: 'getRetailers' }),
    scanners: (props) => props.articleId && ({ name: 'getArticleScanners', props: ['articleId'] }),
    brands: () => ({ name: 'getBrands' }),
    categories: () => ({ name: 'getCategories' }),
}, false)(ArticleModal);

function transformScannersToObject(scanners) {
    const scannersObject = {};
    scanners && scanners.forEach(s => {
        scannersObject[s.retailerId] = s.url;
    });
    return scannersObject;
}
